var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "db relative z--1 navigation",
        class: { show: _vm.navIsOpen }
      },
      [
        _c(
          "div",
          {
            staticClass:
              "db fixed z-999 absolute--fill ph2 ph0-ns flex flex-column items-center content-center justify-center navigation-content"
          },
          [
            _c("transition", { attrs: { name: "bounce" } }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.navIsOpen,
                      expression: "navIsOpen"
                    }
                  ],
                  staticClass: "db relative z-999 center w-100 mw-425px"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "db absolute z-2 left-0 mt2 ml1 grow pointer menu-icon-close",
                      attrs: { alt: "close modal" },
                      on: {
                        click: function($event) {
                          return _vm.closeNav()
                        }
                      }
                    },
                    [
                      _c("span"),
                      _vm._v(" "),
                      _c("span"),
                      _vm._v(" "),
                      _c("span"),
                      _vm._v(" "),
                      _c("span")
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "db relative center w-100 h-100 overflow-hidden"
                    },
                    [
                      _c(
                        "section",
                        {
                          staticClass:
                            "db relative center w-100 h-100 vh-88-xs h-modal-ns ph3 pt0 pt3-ns bg-white br2"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex relative center h-100 flex-column items-center content-center justify-center"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "db relative center w-100 h-auto"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex flex-column mv0 center items-center justify-center content-center"
                                    },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "db w-50 f3 mv2 mh3 tc pointer no-underline is-bebas ttu nav-bg-line-hover",
                                          attrs: { to: "/home/" },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.closeNav()
                                            }
                                          }
                                        },
                                        [_vm._v("Home")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "db w-50 f3 mv2 mh3 tc pointer no-underline is-bebas ttu nav-bg-line-hover",
                                          attrs: { to: "/about/" },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.closeNav()
                                            }
                                          }
                                        },
                                        [_vm._v("About")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "db w-50 f3 mv2 mh3 tc pointer no-underline is-bebas ttu nav-bg-line-hover",
                                          attrs: { to: "/projects/" },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.closeNav()
                                            }
                                          }
                                        },
                                        [_vm._v("Projects")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "db w-50 f3 mv2 mh3 tc pointer no-underline is-bebas ttu nav-bg-line-hover",
                                          attrs: { to: "/gallery/" },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.closeNav()
                                            }
                                          }
                                        },
                                        [_vm._v("Gallery")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "router-link",
                                        {
                                          staticClass:
                                            "db w-50 f3 mv2 mh3 tc pointer no-underline is-bebas ttu nav-bg-line-hover",
                                          attrs: { to: "/partners/" },
                                          nativeOn: {
                                            click: function($event) {
                                              return _vm.closeNav()
                                            }
                                          }
                                        },
                                        [_vm._v("Partners")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "db relative center mt3 mw21rem"
                                    },
                                    [_c("social-icons")],
                                    1
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "db absolute absolute--fill bg-black o-70",
              on: {
                click: function($event) {
                  return _vm.closeNav()
                }
              }
            })
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "db fixed top-0 w-100 z-998 fixed-header" }, [
      _c(
        "div",
        { staticClass: "db relative container-fluid relative ph2 ph3-ns pv2" },
        [
          _c("div", { staticClass: "flex relative flex-row items-center" }, [
            _c(
              "a",
              {
                staticClass:
                  "flex relative flex-row items-center ph2 pt2 pb1 h42px pointer grow btn-generic menu-icon-wrapper",
                class: { isClicked: _vm.navIsOpen },
                on: {
                  click: function($event) {
                    _vm.menuIconIsClicked = !_vm.menuIconIsClicked
                    _vm.openNav()
                  }
                }
              },
              [_vm._m(0)]
            )
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "db absolute left-0 menu-icon pointer" }, [
      _c("span"),
      _vm._v(" "),
      _c("span"),
      _vm._v(" "),
      _c("span"),
      _vm._v(" "),
      _c("span")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }